import React from 'react';
import {NavLink, useNavigate} from 'react-router-dom';
import './Navbar.css';

function Navbar({isAuthenticated, onLogout}) {
    const navigate = useNavigate();
    const navLinkClassName = ({isActive}) => `navbar-link${isActive ? ' is-active' : ''}`;

    const handleLogout = () => {
        onLogout(); // сбрасываем isAuthenticated в false
        navigate('/login');
    };

    return (
        <nav className="navbar" aria-label="Основная навигация">
            <div className="navbar-inner">
                <button className="navbar-logo" type="button" onClick={() => navigate('/')}>
                    <span className="navbar-logo-mark" aria-hidden="true">MS</span>
                    <span>My Shop</span>
                </button>

                <ul className={`navbar-links ${isAuthenticated ? 'navbar-links-auth' : 'navbar-links-guest'}`}>
                    {isAuthenticated ? (
                        <>
                            <li>
                                <NavLink to="/" className={navLinkClassName}>
                                    Каталог
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/cart" className={navLinkClassName}>
                                    Корзина
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/orders" className={navLinkClassName}>
                                    Заказы
                                </NavLink>
                            </li>
                            <li>
                                <button className="navbar-link logout-btn" type="button" onClick={handleLogout}>
                                    Выйти
                                </button>
                            </li>
                        </>
                    ) : (
                        <>
                            <li>
                                <NavLink to="/login" className={navLinkClassName}>
                                    Войти
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/register" className={navLinkClassName}>
                                    Регистрация
                                </NavLink>
                            </li>
                        </>
                    )}
                </ul>
            </div>
        </nav>
    );
}

export default Navbar;
